export const initialState = {
  publishTermAndConditionPage: {}
};
